exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.mat-card-content{\r\n    text-align: center;\r\n}\r\n.mat-card-content p{\r\n    font-size: 19px;\r\n}\r\nmat-form-field{\r\n    width: 80%;\r\n    font-size: 19px;\r\n}\r\nmat-card-actions{\r\n    text-align: center;\r\n}\r\n.mat-card-image:first-child{\r\n    margin: 0 0 20px !important;\r\n}\r\n.mat-card-image {\r\n    width: calc(100%) !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/import-contacts/import-contacts.component.css
// module id = ../../../../../src/app/profile-update/import-contacts/import-contacts.component.css
// module chunks = main